/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Caret } from './Caret';
import { CollapsibleContent as Content } from './Content';
import { CollapsiblePanel as Panel } from './Panel';

export const Collapsible = {
  Panel,
  Content,
  Caret,
};
